import Router from "./Router";
import "./App.css";
import "gestalt/dist/gestalt.css";
import { ClerkProvider, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";

// Import your publishable key
const PUBLISHABLE_KEY_PRODUCTION = "pk_live_Y2xlcmsubWlyd29yay5haSQ";
const PUBLISHABLE_KEY_DEV =
  "pk_test_bmV4dC1zaWxrd29ybS02My5jbGVyay5hY2NvdW50cy5kZXYk";

const publishableKey =
  process.env.NODE_ENV === "development"
    ? PUBLISHABLE_KEY_DEV
    : PUBLISHABLE_KEY_PRODUCTION;
if (!publishableKey) {
  throw new Error("Missing Publishable Key");
}

function App() {
  return (
    <div className="App">
      <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/">
        <SignedOut>
          <RedirectToSignIn />
        </SignedOut>
        <header className="App-header">
          <Router />
        </header>
      </ClerkProvider>
    </div>
  );
}

export default App;
